import styles from "./SampleTracking.module.css";
import { useState } from "react";
import { useSessionStorage } from "react-use";
import { useTranslation } from "react-i18next";
import { Button, Checkbubble } from "@wwg/ui";
import { AddButton } from "shared/components/AddButton/AddButton";
import { CustomerInfoExpander } from "../../CustomerInfoExpander/CustomerInfoExpander";
import { SampleList } from "./SampleList/SampleList";
import { useSamples } from "./useSamples";
import { SampleEdit } from "./SampleEdit/SampleEdit";
import { Modal } from "shared/components/Modal/Modal";
import { ModalContent } from "shared/components/Modal/Modal";
import { ModalControls } from "shared/components/Modal/Modal";
import { ModalHeader } from "shared/components/Modal/Modal";
import { IconSampleTracking } from "shared/icons/IconSampleTracking";
import { ContactsContainer } from "Contacts/useContacts";
import { hasBitwise } from "shared/utils/hasBitwise";
import { CONTACT_TYPE } from "shared/enums";

const SAMPLE_SORT_TYPE = {
  DateDesc: "date-desc",
  DateAsc: "date-asc",
  LikedDesc: "liked-desc",
  LikedAsc: "liked-asc",
};

const SAMPLE_SORT_TYPE_I18N = {
  [SAMPLE_SORT_TYPE.DateDesc]: "sort.labelDateDesc",
  [SAMPLE_SORT_TYPE.DateAsc]: "sort.labelDateAsc",
  [SAMPLE_SORT_TYPE.LikedDesc]: "sort.labelLikedDesc",
  [SAMPLE_SORT_TYPE.LikedAsc]: "sort.labelLikedAsc",
};

export function SampleTracking({ contact }) {
  const { t } = useTranslation();
  const [isAdding, setIsAdding] = useState(false);
  const [isOpen, setIsOpen] = useSessionStorage(
    "customer-sample-tracking-open",
    false
  );

  const [showSortOptions, setShowSortOptions] = useState(false);

  const {
    isLoading,
    isError,
    samples,
    error,
    sortBy,
    setSortBy,
    addSampleMutation,
    updateSampleMutation,
    deleteSampleMutation,
    getTagSuggestions,
  } = useSamples({ contact });

  return (
    <CustomerInfoExpander
      isOpen={isOpen}
      onToggle={setIsOpen}
      icon={<IconSampleTracking width={24} height={24} />}
      title={t("sectionHeaders.sampleTracking")}
      color="#a79d98"
    >
      {isAdding ? (
        <div className={styles.editForm}>
          <SampleEdit
            disabled={addSampleMutation.isLoading}
            sample={{
              tags: [],
              date: new Date(),
              liked: false,
              note: "",
            }}
            onCancel={() => {
              setIsAdding(false);
            }}
            onSubmit={(sample) => {
              // console.log("should save", sample);
              addSampleMutation.mutate(sample)
              setIsAdding(false)
            }}
            getTagSuggestions={getTagSuggestions}
          />
        </div>
      ) : (
        !hasBitwise(CONTACT_TYPE.Archived, contact.type) && (
          <div className={styles.addSampleBar}>
            <AddButton
              onClick={() => {
                setIsAdding(true);
              }}
            >
              {t("buttons.addSample")}
            </AddButton>

            <div className={styles.fixedControls}>
              <Button
                onClick={() => {
                  setShowSortOptions(true);
                }}
              >
                {t("buttons.sort")}
              </Button>
            </div>
          </div>
        )
      )}

      <SampleList
        samples={samples}
        onEditSubmit={(sample) => {
          updateSampleMutation.mutate(sample);
        }}
        onDelete={(sample) => {
          deleteSampleMutation.mutate(sample.id);
        }}
      />

      <Modal isOpen={showSortOptions}>
        <ModalContent>
          <ModalHeader>{t("sort.modalHeader")}</ModalHeader>
          <ul className={styles.sortList}>
            {Object.keys(SAMPLE_SORT_TYPE).map((key) => (
              <li key={key}>
                <Checkbubble
                  isChecked={sortBy === SAMPLE_SORT_TYPE[key]}
                  onChange={(value) => {
                    if (value) {
                      setSortBy(SAMPLE_SORT_TYPE[key]);
                    }
                  }}
                />
                {t(SAMPLE_SORT_TYPE_I18N[SAMPLE_SORT_TYPE[key]])}
              </li>
            ))}
          </ul>
        </ModalContent>
        <ModalControls>
          <Button
            buttonStyle="default"
            onClick={() => {
              setShowSortOptions(false);
            }}
          >
            {t("buttons.close")}
          </Button>
        </ModalControls>
      </Modal>
    </CustomerInfoExpander>
  );
}

SampleTracking.propTypes = {};
